import { render, staticRenderFns } from "./SDS-Powder.vue?vue&type=template&id=a59605d2&scoped=true&"
import script from "./SDS-Powder.vue?vue&type=script&lang=js&"
export * from "./SDS-Powder.vue?vue&type=script&lang=js&"
import style0 from "./SDS-Powder.vue?vue&type=style&index=0&id=a59605d2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a59605d2",
  null
  
)

export default component.exports